<script>
import axios from "axios";

import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
  authApiMethods,
} from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    ...mapState("authapi", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    ...authApiMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        axios
          .post(process.env.VUE_APP_SERVER_URL + "/api/login", {
            email: this.email,
            password: this.password,
          })
          .then(({ data }) => {
            if (data) {
              this.tryingToLogIn = false;
              this.isAuthError = false;

              localStorage.setItem("user", JSON.stringify(data));

              this.$router.push(
                this.$route.query.redirectFrom || {
                  name: "default",
                }
              );

              setTimeout(() => {
                location.reload(true);
              }, 200);
            }else{
                  this.tryingToLogIn = false;
                  this.authError = "Không tìm thấy dữ liệu khớp với tài khoản nhập vào.";
                  this.isAuthError = true;
                  localStorage.removeItem("user");
            }

            // return res;
          })
          .catch((err) => {
              const r = err?.response;
              this.tryingToLogIn = false;

              // Không có phản hồi từ server
              if (!r) {
                this.authError = "Không thể kết nối đến máy chủ.";
                this.isAuthError = true;
                localStorage.removeItem("user");
                return;
              }

              // Lỗi xác thực (422)
              if (r.status === 422 && Array.isArray(r.data?.errors)) {
                console.log("Validation errors:", r.data.errors);
                const firstError = r.data.errors.find(e => e?.msg)?.msg;
                this.authError = firstError || "Dữ liệu không hợp lệ.";
                this.isAuthError = true;
                localStorage.removeItem("user");
                return;
              }
              
              // Lỗi khác (400, 401, 500, v.v.)
              this.authError = r.data || "Đã xảy ra lỗi không xác định.";
              this.isAuthError = true;
              localStorage.removeItem("user");
          });
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Hệ thống quản lí <a href="huthui.com" target="_bank">HUTHUI</a> !</h5>
                  <p>Đăng nhập ngay với hệ thống quản lí</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Nhập email của bạn"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required"
                    >Mật khẩu là được yêu cầu.</span
                  >
                  <span v-if="!$v.email.email"
                    >Làm ơn đăng nhập với email của bạn.</span
                  >
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label="Mật khẩu"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Nhập mật khẩu của bạn"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Mật khẩu là được yêu cầu
                </div>
              </b-form-group>
              <!-- <b-form-checkbox
                  class="form-check"
                  id="customControlInline"
                  name="checkbox-1"
                  value="accepted"
                  unchecked-value="not_accepted"
                >
                  Remember me
                </b-form-checkbox> -->
              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Đăng nhập
                </b-button>
              </div>
              <div class="mt-4 text-center">
                <!-- <router-link to="/forgot-password" class="text-muted"> -->
                <i class="mdi mdi-lock me-1"></i> Quên mật khẩu ? Liên hệ admin
                để cấp lại.
                <!-- </router-link> -->
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
       
          <p>
                 HUTHUI.COM ©
            <i class="mdi mdi-heart text-danger"></i>
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>